import React, { useState } from 'react'
import { Box, Button, Grid } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'

import { Card, DriveTour } from 'components'
import { PartnerInfoForm } from './components'

import useSnackbar from 'hooks/useSnackbar'

import partnerInfoFormSchema from './components/PartnerInfoForm/schema'
import { QuestionnaireForm } from 'views/ThirdPartyManagements/components'

import * as service from 'service'
import helpers from 'helpers'
import { routes } from 'Routes'
import constants from 'constants/index'
import theme from 'theme'

const ImportForm = ({ isPreAvaliation, openTour, setOpenTour }) => {
  const [selectedQuizTemplates, setSelectedQuizTemplates] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const history = useHistory()
  const snackbar = useSnackbar()

  const partnerInfoForm = useForm({
    validationSchema: partnerInfoFormSchema,
    defaultValues: {
      simplifiedRegister: false,
      international: false,
      document: undefined,
      date: null,
      endDate: null,
      supplierAudit: false,
      supplierAuditFrequency: 12,
      supplierAuditFrequencyType: 'months',
    },
  })

  const { STEPS, STEPS_OBJECT } = constants.tours.thirdPartyManagements
  const importTourSteps = isPreAvaliation
    ? STEPS_OBJECT.PRE_AVALIATION.CREATION.IMPORT
    : STEPS_OBJECT.CREATION.IMPORT

  const onSubmit = async () => {
    try {
      const partnerInfoFormDataValid = await partnerInfoForm.triggerValidation()

      if (!partnerInfoFormDataValid) return

      setIsLoading(true)

      const partnerInfoFormData = partnerInfoForm.getValues()

      await service.dponet.suppliers.importSuppliers({
        companySupplier: {
          document: partnerInfoFormData.document,
          simplifiedRegister: partnerInfoFormData.simplifiedRegister,
          international: partnerInfoFormData.international,
          dateToSendEmails: helpers.thirdPartyManegementPartners.formatDate(
            partnerInfoFormData.date,
          ),
          endDate: helpers.thirdPartyManegementPartners.formatDate(
            partnerInfoFormData.endDate,
          ),
          fileToImport: partnerInfoFormData.document,
          quizTemplates: selectedQuizTemplates,
        },
      })

      snackbar.open({
        message:
          'Informaremos por e-mail assim que todos os fornecedores forem cadastrados!',
        variant: 'success',
      })

      history.push(
        isPreAvaliation
          ? routes.thirdPartyManagements.preAvaliations
          : routes.thirdPartyManagements.mySuppliers.all,
      )
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) || 'Ocorreu um erro na importação!',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleReturn = () => {
    history.goBack()
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card
            id={
              isPreAvaliation
                ? STEPS.PRE_AVALIATION.CREATION.IMPORT[2]
                : STEPS.CREATION.IMPORT[2]
            }
            title="Informações do Fornecedor"
          >
            <FormContext {...partnerInfoForm}>
              <PartnerInfoForm />
            </FormContext>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card
            id={
              isPreAvaliation
                ? STEPS.PRE_AVALIATION.CREATION.IMPORT[3]
                : STEPS.CREATION.IMPORT[3]
            }
            title="Questionários"
          >
            <QuestionnaireForm
              selectedQuizTemplates={selectedQuizTemplates}
              setSelectedQuizTemplates={setSelectedQuizTemplates}
              isPreAvaliation={isPreAvaliation}
            />
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="flex-end"
            gridGap={theme.spacing(2)}
          >
            <Button variant="outlined" onClick={handleReturn}>
              Voltar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onSubmit}
              disabled={isLoading}
            >
              Salvar
            </Button>
          </Box>
        </Grid>
      </Grid>

      <DriveTour
        stepsMatrix={importTourSteps}
        open={openTour}
        setOpen={setOpenTour}
      />
    </>
  )
}

export default ImportForm
